'use client';

import Image from 'next/image';

import Badge from '@/app/(football)/[team]/_components/common/Badge';
import type { PointUseType } from '@/store/server/common/football/football.dto';

interface PointLoungeListItemProps {
  type: PointUseType;
  title: string;
  image: string;
  point: number;
  remainAmount: number;
  dateRange: string;
  onClick?: () => void;
}

export default function PointLoungeListItem({
  type,
  title,
  image,
  point,
  remainAmount,
  dateRange,
  onClick,
}: PointLoungeListItemProps) {
  const imageSrcUrl = image?.startsWith('http')
    ? image
    : image
      ? `${process.env.NEXT_PUBLIC_CDN_URL}/${image}`
      : '/images/@/@img_404.svg';

  return (
    <div className="flex w-full flex-col gap-6">
      <div className="flex w-full cursor-pointer flex-row gap-4" onClick={onClick}>
        {/* Image */}
        <div className="h-[120px] w-[120px] shrink-0 rounded gradient-border gradient-border-point-lounge-list-image">
          <div className="relative h-full w-full overflow-hidden rounded bg-point-lounge-list-image-bg">
            <Image src={imageSrcUrl} alt={title} fill style={{ objectFit: 'cover' }} />
          </div>
        </div>

        {/* Content */}
        <div className="flex flex-1 flex-col justify-between gap-4">
          <div className="flex flex-col gap-2">
            <div className="flex flex-row items-center gap-2">
              <Badge variant={type === 'exchange' ? 'exchange' : 'now'}>
                {type === 'exchange' ? '교환' : '즉시추첨'}
              </Badge>
              <span className="typo-body-8 font-medium text-white">{dateRange}</span>
            </div>
            <h3 className="typo-body-1 font-bold text-white">{title}</h3>
          </div>
          <div className="flex flex-row items-center gap-1">
            <span className="typo-body-1 font-bold text-white">{point.toLocaleString('ko-KR')}P</span>
            <span className="typo-body-8 font-medium text-point-lounge-list-sub-text">
              (잔여 수량 : {remainAmount}개)
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
